export default __webpack_public_path__ + "static/media/CarriePhoto.574cd536.jpg";